import { Injectable } from "@angular/core";
import { ApiService } from "../../../shared/services/api.service";
import { IDomainAllowlist, IPostDomainAllowlist, IPatchDomainAllowlist } from "../models/domain-allowlist";


@Injectable({
  providedIn: 'root',
})
export class DomainAllowlistService {
  constructor(private apiService: ApiService) {}
  readonly root = 'api/domain-allowlist';

  public getDomainAllowlist() {
    const fullAPIUrl = this.apiService.buildFullURL(this.root, ``);
    return this.apiService.get<IDomainAllowlist[]>(fullAPIUrl, { withCredentials: true });
  }

  public postDomainAllowlist(item: IPostDomainAllowlist) {
    const fullAPIUrl = this.apiService.buildFullURL(this.root, ``);
    return this.apiService.post<IDomainAllowlist>(fullAPIUrl, item, { withCredentials: true });
  }

  public patchDomainAllowlist(id: number, changes: IPatchDomainAllowlist) {
    const fullAPIUrl = this.apiService.buildFullURL(this.root, `${id}/`);
    return this.apiService.patch<IDomainAllowlist>(fullAPIUrl, changes, { withCredentials: true });
  }

  public deleteDomainAllowlist(id: number) {
    const fullAPIUrl = this.apiService.buildFullURL(this.root, `${id}/`);
    return this.apiService.delete(fullAPIUrl, { withCredentials: true });
  }
}
